// Gerado por scripts/build-icons.mjs — não editar manualmente.
import type { BankIconComponent } from "./createBankIcon";
import { banksData, getBankByCompe, getBankBySlug, type BankData } from "./data";
import { NinetyNinePay } from "./icons/NinetyNinePay";
import { ABCBrasil } from "./icons/ABCBrasil";
import { Adyen } from "./icons/Adyen";
import { Agibank } from "./icons/Agibank";
import { Ailos } from "./icons/Ailos";
import { Alelo } from "./icons/Alelo";
import { Almah } from "./icons/Almah";
import { Amazon } from "./icons/Amazon";
import { AmazonPrime } from "./icons/AmazonPrime";
import { Americanas } from "./icons/Americanas";
import { AmericanExpress } from "./icons/AmericanExpress";
import { ApplePay } from "./icons/ApplePay";
import { Arbi } from "./icons/Arbi";
import { Artta } from "./icons/Artta";
import { Asaas } from "./icons/Asaas";
import { Atacadao } from "./icons/Atacadao";
import { Avenue } from "./icons/Avenue";
import { Azul } from "./icons/Azul";
import { BancoDaAmazonia } from "./icons/BancoDaAmazonia";
import { BancoDoBrasil } from "./icons/BancoDoBrasil";
import { BancoDoBrasilInfinite } from "./icons/BancoDoBrasilInfinite";
import { BancoDoNordeste } from "./icons/BancoDoNordeste";
import { BancoMaster } from "./icons/BancoMaster";
import { Banese } from "./icons/Banese";
import { Banestes } from "./icons/Banestes";
import { Bankly } from "./icons/Bankly";
import { BankOfAmerica } from "./icons/BankOfAmerica";
import { Banpara } from "./icons/Banpara";
import { Banrisul } from "./icons/Banrisul";
import { BanrisulInfinite } from "./icons/BanrisulInfinite";
import { Bari } from "./icons/Bari";
import { BeesBank } from "./icons/BeesBank";
import { Binance } from "./icons/Binance";
import { Bitget } from "./icons/Bitget";
import { Bitso } from "./icons/Bitso";
import { BKBank } from "./icons/BKBank";
import { BMG } from "./icons/BMG";
import { BMP } from "./icons/BMP";
import { BNPParibas } from "./icons/BNPParibas";
import { Bradesco } from "./icons/Bradesco";
import { BradescoInfinite } from "./icons/BradescoInfinite";
import { BRB } from "./icons/BRB";
import { Brex } from "./icons/Brex";
import { BS2 } from "./icons/BS2";
import { BTGPactual } from "./icons/BTGPactual";
import { BTGUltrablue } from "./icons/BTGUltrablue";
import { BV } from "./icons/BV";
import { Bybit } from "./icons/Bybit";
import { C6Bank } from "./icons/C6Bank";
import { C6Carbon } from "./icons/C6Carbon";
import { C6Global } from "./icons/C6Global";
import { Caixa } from "./icons/Caixa";
import { Caju } from "./icons/Caju";
import { Capitual } from "./icons/Capitual";
import { Carrefour } from "./icons/Carrefour";
import { CasasBahia } from "./icons/CasasBahia";
import { CashApp } from "./icons/CashApp";
import { CeA } from "./icons/CeA";
import { Celcoin } from "./icons/Celcoin";
import { Citibank } from "./icons/Citibank";
import { CloudWalk } from "./icons/CloudWalk";
import { Coinbase } from "./icons/Coinbase";
import { Colombo } from "./icons/Colombo";
import { ContaAzul } from "./icons/ContaAzul";
import { ContaSimples } from "./icons/ContaSimples";
import { Contbank } from "./icons/Contbank";
import { Cora } from "./icons/Cora";
import { CrediSIS } from "./icons/CrediSIS";
import { Creditas } from "./icons/Creditas";
import { Cresol } from "./icons/Cresol";
import { CryptoCom } from "./icons/CryptoCom";
import { Daycoval } from "./icons/Daycoval";
import { Decolar } from "./icons/Decolar";
import { DeutscheBank } from "./icons/DeutscheBank";
import { Digimais } from "./icons/Digimais";
import { Digio } from "./icons/Digio";
import { DinersClub } from "./icons/DinersClub";
import { Discover } from "./icons/Discover";
import { Dock } from "./icons/Dock";
import { Edenred } from "./icons/Edenred";
import { EfiBank } from "./icons/EfiBank";
import { Fibra } from "./icons/Fibra";
import { Fidelity } from "./icons/Fidelity";
import { Flash } from "./icons/Flash";
import { GooglePay } from "./icons/GooglePay";
import { Grafeno } from "./icons/Grafeno";
import { Havan } from "./icons/Havan";
import { Hipercard } from "./icons/Hipercard";
import { BancoHonda } from "./icons/BancoHonda";
import { IFood } from "./icons/IFood";
import { IfoodPago } from "./icons/IfoodPago";
import { Inbursa } from "./icons/Inbursa";
import { IndustrialDoBrasil } from "./icons/IndustrialDoBrasil";
import { InfinitePay } from "./icons/InfinitePay";
import { Inter } from "./icons/Inter";
import { InterGlobal } from "./icons/InterGlobal";
import { Itau } from "./icons/Itau";
import { ItauBlack } from "./icons/ItauBlack";
import { ItauPersonnalite } from "./icons/ItauPersonnalite";
import { ItauTheOne } from "./icons/ItauTheOne";
import { ItauUniclass } from "./icons/ItauUniclass";
import { Iugu } from "./icons/Iugu";
import { JCB } from "./icons/JCB";
import { Kabum } from "./icons/Kabum";
import { Klarna } from "./icons/Klarna";
import { Klavi } from "./icons/Klavi";
import { LatamPass } from "./icons/LatamPass";
import { Leader } from "./icons/Leader";
import { LetsBank } from "./icons/LetsBank";
import { Linker } from "./icons/Linker";
import { Livelo } from "./icons/Livelo";
import { Maestro } from "./icons/Maestro";
import { MagaluPay } from "./icons/MagaluPay";
import { Marisa } from "./icons/Marisa";
import { Mastercard } from "./icons/Mastercard";
import { Meliuz } from "./icons/Meliuz";
import { MercadoBitcoin } from "./icons/MercadoBitcoin";
import { MercadoPago } from "./icons/MercadoPago";
import { Mercantil } from "./icons/Mercantil";
import { Mizuho } from "./icons/Mizuho";
import { Modobank } from "./icons/Modobank";
import { MorganStanley } from "./icons/MorganStanley";
import { MUFG } from "./icons/MUFG";
import { MultiploBank } from "./icons/MultiploBank";
import { N26 } from "./icons/N26";
import { Neon } from "./icons/Neon";
import { Neteller } from "./icons/Neteller";
import { Next } from "./icons/Next";
import { NGCash } from "./icons/NGCash";
import { Nomad } from "./icons/Nomad";
import { Nubank } from "./icons/Nubank";
import { NubankCroma } from "./icons/NubankCroma";
import { NubankUltravioleta } from "./icons/NubankUltravioleta";
import { OKX } from "./icons/OKX";
import { OmieCash } from "./icons/OmieCash";
import { Omni } from "./icons/Omni";
import { Onfly } from "./icons/Onfly";
import { Original } from "./icons/Original";
import { OriginalBlack } from "./icons/OriginalBlack";
import { OriginalGold } from "./icons/OriginalGold";
import { OriginalInternational } from "./icons/OriginalInternational";
import { OriginalPlatinum } from "./icons/OriginalPlatinum";
import { OrionPay } from "./icons/OrionPay";
import { Ourinvest } from "./icons/Ourinvest";
import { Outros } from "./icons/Outros";
import { PagarMe } from "./icons/PagarMe";
import { PagBank } from "./icons/PagBank";
import { Pan } from "./icons/Pan";
import { Paulista } from "./icons/Paulista";
import { PayCash } from "./icons/PayCash";
import { Payoneer } from "./icons/Payoneer";
import { PayPal } from "./icons/PayPal";
import { Pernambucanas } from "./icons/Pernambucanas";
import { PicPay } from "./icons/PicPay";
import { PicPayBlack } from "./icons/PicPayBlack";
import { PinBank } from "./icons/PinBank";
import { Pine } from "./icons/Pine";
import { Pluggy } from "./icons/Pluggy";
import { Pluxee } from "./icons/Pluxee";
import { Polishop } from "./icons/Polishop";
import { Ponto } from "./icons/Ponto";
import { Porto } from "./icons/Porto";
import { PortoBlack } from "./icons/PortoBlack";
import { PortoInfinite } from "./icons/PortoInfinite";
import { QITech } from "./icons/QITech";
import { Qive } from "./icons/Qive";
import { QualityDigitalBank } from "./icons/QualityDigitalBank";
import { QueroQuero } from "./icons/QueroQuero";
import { Rabobank } from "./icons/Rabobank";
import { RappiCard } from "./icons/RappiCard";
import { RecargaPay } from "./icons/RecargaPay";
import { Rendimento } from "./icons/Rendimento";
import { Renner } from "./icons/Renner";
import { Revolut } from "./icons/Revolut";
import { Riachuelo } from "./icons/Riachuelo";
import { Rico } from "./icons/Rico";
import { Ripio } from "./icons/Ripio";
import { Robinhood } from "./icons/Robinhood";
import { Safra } from "./icons/Safra";
import { SafraInfiniteIridium } from "./icons/SafraInfiniteIridium";
import { Samsung } from "./icons/Samsung";
import { Santander } from "./icons/Santander";
import { SantanderElite } from "./icons/SantanderElite";
import { SantanderUnique } from "./icons/SantanderUnique";
import { CharlesSchwab } from "./icons/CharlesSchwab";
import { Sicoob } from "./icons/Sicoob";
import { SicoobVerth } from "./icons/SicoobVerth";
import { Sicredi } from "./icons/Sicredi";
import { SicrediInfinite } from "./icons/SicrediInfinite";
import { Sisprime } from "./icons/Sisprime";
import { Skrill } from "./icons/Skrill";
import { SocieteGenerale } from "./icons/SocieteGenerale";
import { Sofisa } from "./icons/Sofisa";
import { Square } from "./icons/Square";
import { Squid } from "./icons/Squid";
import { StarkBank } from "./icons/StarkBank";
import { BancoStellantis } from "./icons/BancoStellantis";
import { Stone } from "./icons/Stone";
import { Stripe } from "./icons/Stripe";
import { Sulcredi } from "./icons/Sulcredi";
import { SumitomoMitsui } from "./icons/SumitomoMitsui";
import { SumUp } from "./icons/SumUp";
import { Swile } from "./icons/Swile";
import { Ticket } from "./icons/Ticket";
import { Ton } from "./icons/Ton";
import { Topazio } from "./icons/Topazio";
import { Toro } from "./icons/Toro";
import { BancoToyota } from "./icons/BancoToyota";
import { Transfeera } from "./icons/Transfeera";
import { Tribanco } from "./icons/Tribanco";
import { Unicred } from "./icons/Unicred";
import { UnionPay } from "./icons/UnionPay";
import { Uniprime } from "./icons/Uniprime";
import { UzziPay } from "./icons/UzziPay";
import { Venmo } from "./icons/Venmo";
import { Visa } from "./icons/Visa";
import { VisaElectron } from "./icons/VisaElectron";
import { BancoVolkswagen } from "./icons/BancoVolkswagen";
import { VRBeneficios } from "./icons/VRBeneficios";
import { Warren } from "./icons/Warren";
import { WillBank } from "./icons/WillBank";
import { Wise } from "./icons/Wise";
import { XP } from "./icons/XP";
import { XPGlobal } from "./icons/XPGlobal";
import { Zelle } from "./icons/Zelle";
import { Zema } from "./icons/Zema";
import { ZemoBank } from "./icons/ZemoBank";
import { ZroBank } from "./icons/ZroBank";

export interface Bank extends BankData {
  /** Componente React do ícone */
  Icon: BankIconComponent;
}

const ICONS: Record<string, BankIconComponent> = {
  "99pay": NinetyNinePay,
  "abcbrasil": ABCBrasil,
  "adyen": Adyen,
  "agibank": Agibank,
  "ailos": Ailos,
  "alelo": Alelo,
  "almah": Almah,
  "amazon": Amazon,
  "amazonprime": AmazonPrime,
  "americanas": Americanas,
  "amex": AmericanExpress,
  "applepay": ApplePay,
  "arbi": Arbi,
  "artta": Artta,
  "asaas": Asaas,
  "atacadao": Atacadao,
  "avenue": Avenue,
  "azul": Azul,
  "bancodaamazonia": BancoDaAmazonia,
  "bancodobrasil": BancoDoBrasil,
  "bancodobrasilinfinite": BancoDoBrasilInfinite,
  "bancodonordeste": BancoDoNordeste,
  "bancomaster": BancoMaster,
  "banese": Banese,
  "banestes": Banestes,
  "bankly": Bankly,
  "bankofamerica": BankOfAmerica,
  "banpara": Banpara,
  "banrisul": Banrisul,
  "banrisulinfinite": BanrisulInfinite,
  "bari": Bari,
  "beesbank": BeesBank,
  "binance": Binance,
  "bitget": Bitget,
  "bitso": Bitso,
  "bkbank": BKBank,
  "bmg": BMG,
  "bmp": BMP,
  "bnpparibas": BNPParibas,
  "bradesco": Bradesco,
  "bradescoinfinite": BradescoInfinite,
  "brb": BRB,
  "brex": Brex,
  "bs2": BS2,
  "btgpactual": BTGPactual,
  "btgultrablue": BTGUltrablue,
  "bv": BV,
  "bybit": Bybit,
  "c6bank": C6Bank,
  "c6carbon": C6Carbon,
  "c6global": C6Global,
  "caixa": Caixa,
  "caju": Caju,
  "capitual": Capitual,
  "carrefour": Carrefour,
  "casasbahia": CasasBahia,
  "cashapp": CashApp,
  "cea": CeA,
  "celcoin": Celcoin,
  "citibank": Citibank,
  "cloudwalk": CloudWalk,
  "coinbase": Coinbase,
  "colombo": Colombo,
  "contaazul": ContaAzul,
  "contasimples": ContaSimples,
  "contbank": Contbank,
  "cora": Cora,
  "credisis": CrediSIS,
  "creditas": Creditas,
  "cresol": Cresol,
  "cryptocom": CryptoCom,
  "daycoval": Daycoval,
  "decolar": Decolar,
  "deutsche": DeutscheBank,
  "digimais": Digimais,
  "digio": Digio,
  "dinersclub": DinersClub,
  "discover": Discover,
  "dock": Dock,
  "edenred": Edenred,
  "efibank": EfiBank,
  "fibra": Fibra,
  "fidelity": Fidelity,
  "flash": Flash,
  "googlepay": GooglePay,
  "grafeno": Grafeno,
  "havan": Havan,
  "hipercard": Hipercard,
  "honda": BancoHonda,
  "ifood": IFood,
  "ifoodpago": IfoodPago,
  "inbursa": Inbursa,
  "industrialdobrasil": IndustrialDoBrasil,
  "infinitepay": InfinitePay,
  "inter": Inter,
  "interglobal": InterGlobal,
  "itau": Itau,
  "itaublack": ItauBlack,
  "itaupersonnalite": ItauPersonnalite,
  "itautheone": ItauTheOne,
  "itauuniclass": ItauUniclass,
  "iugu": Iugu,
  "jcb": JCB,
  "kabum": Kabum,
  "klarna": Klarna,
  "klavi": Klavi,
  "latampass": LatamPass,
  "leader": Leader,
  "letsbank": LetsBank,
  "linker": Linker,
  "livelo": Livelo,
  "maestro": Maestro,
  "magalupay": MagaluPay,
  "marisa": Marisa,
  "mastercard": Mastercard,
  "meliuz": Meliuz,
  "mercadobitcoin": MercadoBitcoin,
  "mercadopago": MercadoPago,
  "mercantil": Mercantil,
  "mizuho": Mizuho,
  "modobank": Modobank,
  "morganstanley": MorganStanley,
  "mufg": MUFG,
  "multiplobank": MultiploBank,
  "n26": N26,
  "neon": Neon,
  "neteller": Neteller,
  "next": Next,
  "ngcash": NGCash,
  "nomad": Nomad,
  "nubank": Nubank,
  "nubankcroma": NubankCroma,
  "nubankultravioleta": NubankUltravioleta,
  "okx": OKX,
  "omiecash": OmieCash,
  "omni": Omni,
  "onfly": Onfly,
  "original": Original,
  "originalblack": OriginalBlack,
  "originalgold": OriginalGold,
  "originalinternational": OriginalInternational,
  "originalplatinum": OriginalPlatinum,
  "orionpay": OrionPay,
  "ourinvest": Ourinvest,
  "outros": Outros,
  "pagarme": PagarMe,
  "pagbank": PagBank,
  "pan": Pan,
  "paulista": Paulista,
  "paycash": PayCash,
  "payoneer": Payoneer,
  "paypal": PayPal,
  "pernambucanas": Pernambucanas,
  "picpay": PicPay,
  "picpayblack": PicPayBlack,
  "pinbank": PinBank,
  "pine": Pine,
  "pluggy": Pluggy,
  "pluxee": Pluxee,
  "polishop": Polishop,
  "ponto": Ponto,
  "porto": Porto,
  "portoblack": PortoBlack,
  "portoinfinite": PortoInfinite,
  "qitech": QITech,
  "qive": Qive,
  "qualitybank": QualityDigitalBank,
  "queroquero": QueroQuero,
  "rabobank": Rabobank,
  "rappicard": RappiCard,
  "recargapay": RecargaPay,
  "rendimento": Rendimento,
  "renner": Renner,
  "revolut": Revolut,
  "riachuelo": Riachuelo,
  "rico": Rico,
  "ripio": Ripio,
  "robinhood": Robinhood,
  "safra": Safra,
  "safrainfiniteiridium": SafraInfiniteIridium,
  "samsung": Samsung,
  "santander": Santander,
  "santanderelite": SantanderElite,
  "santanderunique": SantanderUnique,
  "schwab": CharlesSchwab,
  "sicoob": Sicoob,
  "sicoobverth": SicoobVerth,
  "sicredi": Sicredi,
  "sicrediinfinite": SicrediInfinite,
  "sisprime": Sisprime,
  "skrill": Skrill,
  "socgen": SocieteGenerale,
  "sofisa": Sofisa,
  "square": Square,
  "squid": Squid,
  "starkbank": StarkBank,
  "stellantis": BancoStellantis,
  "stone": Stone,
  "stripe": Stripe,
  "sulcredi": Sulcredi,
  "sumitomo": SumitomoMitsui,
  "sumup": SumUp,
  "swile": Swile,
  "ticket": Ticket,
  "ton": Ton,
  "topazio": Topazio,
  "toro": Toro,
  "toyota": BancoToyota,
  "transfeera": Transfeera,
  "tribanco": Tribanco,
  "unicred": Unicred,
  "unionpay": UnionPay,
  "uniprime": Uniprime,
  "uzzipay": UzziPay,
  "venmo": Venmo,
  "visa": Visa,
  "visaelectron": VisaElectron,
  "volkswagen": BancoVolkswagen,
  "vrbeneficios": VRBeneficios,
  "warren": Warren,
  "willbank": WillBank,
  "wise": Wise,
  "xp": XP,
  "xpglobal": XPGlobal,
  "zelle": Zelle,
  "zema": Zema,
  "zemobank": ZemoBank,
  "zrobank": ZroBank,
};

/** Todos os bancos, cartões e carteiras disponíveis (com componente), em ordem alfabética de slug. */
export const banks: Bank[] = banksData.map((b) => ({ ...b, Icon: ICONS[b.slug] }));

/**
 * Busca um banco pelo slug ("nubank") ou código COMPE ("260" ou 260).
 * @deprecated Prefira getBankBySlug, getBankByCompe ou getBankByName —
 * e, em Node/APIs sem React, importe de "react-bancos/data".
 */
export function getBank(query: string | number): Bank | undefined {
  const hit = getBankBySlug(String(query)) ?? getBankByCompe(query);
  return hit && banks.find((b) => b.slug === hit.slug);
}
